export default __webpack_public_path__ + "static/typography-image-t-80f04eb91fbeeddb9c32d8f37b60aac0.png";